exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "/* Ensure the card content allows the table to expand naturally */\nmd-card-content {\n  display: block;\n}\n\n/* Make the table fill available width and expand with content */\n.custom-table {\n  width: 100%;\n  table-layout: auto;\n}\n\n/* Ensure table rows have adequate spacing */\n.custom-table tbody tr {\n  min-height: 48px;\n}\n\n/* Spinner alignment */\n.col.v-middle {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  padding: 2rem;\n}\n\n/* Status column styling */\n.status-draft {\n  color: #ff9800;\n  font-weight: 500;\n}\n\n.status-final {\n  color: #4caf50;\n  font-weight: 500;\n}\n\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/entities/transaction-profile/transaction-rule/transaction-rule.component.css
// module id = 2000
// module chunks = 0